import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
  Inject,
} from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ElementRef } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MyErrorStateMatcher, RequireMatch } from "src/app/utils/requireMatch";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";

@Component({
  selector: "app-modal-asignar",
  templateUrl: "./modal.component.html",
})
export class AsignarModal implements OnInit {
  @ViewChild("polizaInput", { static: false })
  public polizaInput: ElementRef;

  public form: FormGroup;
  public mode: "stanby" | "create" | "update" = "stanby";
  public defaults?: any = undefined;

  @Output() onsave = new EventEmitter<{ mode: string; value: any }>();
  polizaImg: string = "";
  polizaFile: File = undefined;
  listS: any[] = [];
  listC: any[] = [];

  filteredOptionsS: Observable<any[]>;
  filteredOptionsC: Observable<any[]>;
  matcher = new MyErrorStateMatcher();
  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<AsignarModal>,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  public ngOnInit() {
    this.listS = this.data.listS;
    this.listC = this.data.listC;
    this.buildForm();
  }

  // TODO add validators
  private buildForm() {
    this.form = this.fb.group({
      Chofer: new FormControl("", [Validators.required, RequireMatch]),
      Supervisor: new FormControl("", [Validators.required, RequireMatch]),
    });
    this.filteredOptionsC = this.form.controls["Chofer"].valueChanges.pipe(
      startWith(""),
      map((value) => this._filterC(value))
    );
    this.filteredOptionsS = this.form.controls["Supervisor"].valueChanges.pipe(
      startWith(""),
      map((value) => this._filterS(value))
    );
  }

  save() {
    const data = this.form.value;
    this.dialogRef.close({
      IdChofer: data.Chofer.Id,
      IdSupervisor: data.Supervisor.Id,
    });
  }

  displayWith(item?: any): string | undefined {
    return item ? item.Desc : undefined;
  }
  private _filterC(value: any): string[] {
    let filterValue;
    if (typeof value === "string") filterValue = value.toLowerCase();
    else filterValue = value.Desc.toLowerCase();

    return this.listC.filter((option) =>
      option.Desc.toLowerCase().includes(filterValue)
    );
  }
  private _filterS(value: any): string[] {
    let filterValue;
    if (typeof value === "string") filterValue = value.toLowerCase();
    else filterValue = value.Desc.toLowerCase();

    return this.listS.filter((option) =>
      option.Desc.toLowerCase().includes(filterValue)
    );
  }
}
